import { Color, DefaultValue, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

import { Themable } from '../../types/themable'

type DirectDebitWrapperProps = Themable & {
  isFaded: boolean
  horizontal?: boolean
}

export const DirectDebitWrapper = styled.div<DirectDebitWrapperProps>`
  display: flex;
  box-sizing: border-box;
  opacity: ${({ isFaded }) => (isFaded ? 0.3 : 1)};
  align-items: ${({ horizontal }) => (horizontal ? 'center' : 'flex-start')};
  flex-direction: ${({ horizontal }) => (horizontal ? 'row' : 'column')};
  justify-content: ${({ horizontal }) => (horizontal ? 'flex-start' : 'space-between')};
  width: 100%;
  height: ${({ horizontal }) => (horizontal ? '56px' : '148px')};
  margin: ${({ horizontal }) => (horizontal ? 0 : Spacing.S24)} 0;
  padding: ${({ horizontal }) => (horizontal ? Spacing.S8 : Spacing.S24)};
  border: ${({ theme }) => `1px solid ${Color.Grey150}`};
  border-radius: ${DefaultValue.BorderRadius};
  background-color: ${Color.White};
  box-shadow: ${`0 2px 1px ${Color.Grey150}`};
`

interface IssuerLogoWrapperProps {
  horizontal?: boolean
}

export const IssuerLogoWrapper = styled.div<IssuerLogoWrapperProps>`
  display: flex;
  ${({ horizontal }) => horizontal && `margin-right: ${Spacing.S16};`}
`
